import styled from 'styled-components';
import CommonTable from 'components/table/CommonTable';
import { AutomatedReviewLog } from 'models/automation/Reviews';

export const AutomatedReviewLogsTableStyled = styled(
  CommonTable<AutomatedReviewLog>,
)`
  .column-status {
    width: 130px;
  }

  .column-channel {
    width: 120px;
  }

  .column-actions {
    width: 100px;
  }
`;
